
import { useState, useEffect } from 'react';

export const useExitIntent = () => {
  const [showExitIntent, setShowExitIntent] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    const handleMouseLeave = (e: MouseEvent) => {
      // Detectar quando o mouse sai pela parte superior da página
      if (e.clientY <= 0) {
        setShowExitIntent(true);
      }
    };

    const handleVisibilityChange = () => {
      // Detectar quando o usuário muda de aba ou minimiza o navegador
      if (document.visibilityState === 'hidden') {
        setShowExitIntent(true);
      }
    };

    const handleBeforeUnload = () => {
      // Detectar quando o usuário tenta fechar a aba/navegador
      setShowExitIntent(true);
    };

    // Adicionar delay para evitar ativação acidental no carregamento
    timeoutId = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('beforeunload', handleBeforeUnload);
    }, 3000); // Só ativar após 3 segundos na página

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const resetExitIntent = () => {
    setShowExitIntent(false);
  };

  return { showExitIntent, resetExitIntent };
};
